<template>
    <div class="main-layout">
        <NavBar />
        <SideBar @sidebar-toggle="handleSidebarToggle" />

        <main class="content" :class="{ 'content-expanded': sidebarCollapsed }">
            <router-view></router-view>

            <!-- Bouton de retour en haut de page -->
            <button v-show="showScrollTop" @click="scrollToTop" class="scroll-top-button"
                aria-label="Retour en haut de la page">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
            </button>
        </main>
    </div>
</template>

<script>
import NavBar from './NavBar.vue';
import SideBar from './SideBar.vue';
import CashRegisterService from '@/services/cashRegisterService'
import physicalInventoryService from '@/services/physicalInventoryService'
import companySettingService from '@/services/companySettingService'
import companyService from '@/services/companyService'

export default {
    name: 'MainLayout',
    components: {
        NavBar,
        SideBar
    },
    data() {
        return {
            sidebarCollapsed: false,
            showScrollTop: false,
            company: null
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.getMyOpenedCashRegister();
        if (this.isMobileDevice()) {
            this.checkOngoingInventory().then(hasOngoingInventory => {
                console.log('hasOngoingInventory():', hasOngoingInventory)
                if (hasOngoingInventory) {
                    this.$router.push({ name: 'doing-inventory' })
                }
            })
        }

        this.getCompanySettings().then(settings => {
            console.log('settings():', settings)
        });

        this.getCurrentCompany().then(company => {
            console.log('company() ===> :', company)
        });
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        async getMyOpenedCashRegister() {
            CashRegisterService.pullAndSaveOpenedCashRegister();
        },
        handleSidebarToggle(collapsed) {
            this.sidebarCollapsed = collapsed;
        },
        handleScroll() {
            this.showScrollTop = window.scrollY > 300;
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },

        isMobileDevice() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                window.innerWidth <= 768
        },

        async checkOngoingInventory() {
            try {
                const response = await physicalInventoryService.getInventories({
                    status: 'in_progress',
                    per_page: 1,
                    page: 1
                })

                return response.data && response.data.length > 0
            } catch (error) {
                console.error('Erreur lors de la vérification de l\'inventaire:', error)
                return false
            }
        },
        async getCompanySettings() {
            try {
                const response = await companySettingService.getCompanySettings();
                localStorage.setItem('company_settings', JSON.stringify(response.data.data))
                console.log('company_settings():', localStorage.getItem('company_settings'))
            } catch (error) {
                console.error('Erreur lors de la récupération des paramètres de l\'entreprise:', error)
            }
        },
        async getCurrentCompany() {
            try {
                const response = await companyService.getCompanyCurrent();
                console.log('response():', response.data.data)
                localStorage.setItem('company', JSON.stringify(response.data.data))
                console.log('company():', localStorage.getItem('company'))
            } catch (error) {
                console.error('Erreur lors de la récupération de l\'entreprise:', error)
            }
        }
    }
}
</script>

<style scoped>
.main-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f5f5f5;
}

.content {
    margin-left: 250px;
    /* Largeur initiale du sidebar (w-[250px]) */
    margin-top: 64px;
    /* Hauteur de la navbar */
    padding: 20px;
    transition: margin-left 0.3s ease;
    min-height: calc(100vh - 64px);
    position: relative;
}

.content-expanded {
    margin-left: 80px;
    /* Largeur du sidebar réduit (w-20 = 5rem = 80px) */
}

.scroll-top-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #0A5C6B;
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(10, 92, 107, 0.3);
    transition: all 0.2s ease;
    z-index: 100;
}

.scroll-top-button:hover {
    background-color: #3FDA4D;
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(63, 218, 77, 0.4);
}

@media (max-width: 768px) {
    .content {
        margin-left: 0;
        padding: 15px;
    }

    .content-expanded {
        margin-left: 0;
    }
}
</style>